module.exports = __webpack_public_path__ + "static/media/banner2.63aec9e9.jpg";